import React from 'react';
import { BuilderActionType, BuilderContext } from './state';
import { getStyleProperties } from '../../utils/builderUtils';
import NumberInput from './NumberInput';
import { Crop } from '../../Components/Icon';
import { BuilderPanel } from './BuilderPanel';

type Props = {
    selector: string;
};

function DimensionSelector({ selector }: Props) {
    const styleObj = getStyleProperties(selector, ['width', 'height']);
    const [dimension, setDimension] = React.useState({ ...styleObj });
    const { dispatch } = React.useContext(BuilderContext);

    const handleChange = (name: string, value: string) => {
        setDimension({ ...dimension, [name]: value });
        dispatch({
            type: BuilderActionType.UPDATE_CSS,
            payload: {
                selector,
                properties: { ...dimension, [name]: value },
            },
        });
    };

    return (
        <BuilderPanel
            title="Dimension"
            icon={<Crop className="h-4 w-4" />}
            className="mt-5"
            bodyClassName="grid gap-3 sm:grid-cols-2"
        >
            <div>
                <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                    Width
                </p>
                <NumberInput
                    options={['%', 'px']}
                    defaultOption="%"
                    value={dimension.width}
                    onChange={handleChange}
                    name="width"
                />
            </div>
            <div>
                <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                    Height
                </p>
                <NumberInput
                    options={['%', 'px']}
                    defaultOption="%"
                    value={dimension.height}
                    onChange={handleChange}
                    name="height"
                />
            </div>
        </BuilderPanel>
    );
}

export default DimensionSelector;
